var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.98,0 C6.259,0 0,6.261 0,13.983 C0,21.704 6.259,27.965 13.98,27.965 C21.705,27.965 27.965,21.703 27.965,13.983 C27.965,6.261 21.705,0 13.98,0 Z M19.992,17.769 L17.765,19.993 C17.765,19.993 14.242,16.213 13.979,16.213 C13.72,16.213 10.196,19.993 10.196,19.993 L7.968,17.769 C7.968,17.769 11.752,14.297 11.752,13.988 C11.752,13.674 7.968,10.201 7.968,10.201 L10.196,7.972 C10.196,7.972 13.749,11.754 13.979,11.754 C14.211,11.754 17.765,7.972 17.765,7.972 L19.992,10.201 C19.992,10.201 16.207,13.724 16.207,13.988 C16.207,14.239 19.992,17.769 19.992,17.769 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.88b843a3.svg";
export { ForwardRef as ReactComponent };